import { width } from "@mui/system";
import React, { useState, useRef } from "react";
import { Picker, View, Text, StyleSheet, ScrollView, SafeAreaView, Image, TouchableOpacity, Switch, Dimensions } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Icon from 'react-native-vector-icons/FontAwesome';
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { ComponentToPrintEvaprator } from "../../../Components/ComponentToPrintEvaprator";
import ReactToPrint from 'react-to-print';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: 'red',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));
const ResultEvaprator = props => {
    const { t, i18n } = useTranslation();
    const componentRef = useRef();
    const classes = useStyles();
    const [selectwhich, Setselectwich] = useState(1);
    const [dataevap, setEvapData] = useState(() => { item => setEvapData(item) });
    const [itemsEvapTemp, setEvapTempItems] = useState([]);
    const [selectevaprator, Setselectevaprator] = useState(0);
    const [zarfiyatnami, setzarfiyatnami] = useState("-");
    const [sizefan, setsizefan] = useState("-");
    const [faselefin, setfaselefin] = useState("-");
    const [sathtabadolhararat, setsathtabadolhararat] = useState("-");
    const [gazgiri, setgazgiri] = useState("-");
    const [tedadfan, settedadfan] = useState("-");
    const [debi, setdebi] = useState("-");
    const [partabbad, setpartabbad] = useState("-");
    const [vorodi, setvorodi] = useState("-");
    const [khoroji, setkhoroji] = useState("-");
    const [vazn, setvazn] = useState("-");
    const [sorat, setsorat] = useState("-");
    const [ip, setip] = useState("-");
    const [voltajfan, setvoltajfan] = useState("-");
    const [ferekans, setferekans] = useState("-");
    const [jaryanfan, setjaryanfan] = useState("-");
    const [tavanfan, settavanfan] = useState("-");
    const [voltajdefrost, setvoltajdefrost] = useState("-");
    const [jaryandefrost, setjaryandefrost] = useState("-");
    const [tavandefrost, settavandefrost] = useState("-");
    const [urlshematic, seturlshematic] = useState("-");
    const [searchedtxt, SetSearchedTxt] = useState(props.route.params.TITLE);
    const [imageHeight, setimageHeight] = useState(400);
    const [imageWidth, setimageWidth] = useState(400);
    let dimensions = 0;
    const [issearching, Setissearching] = useState(false);
    const [showmessage, Setshowmessage] = useState(false);
    const [isTempHelpEnabled, setIsTempHelpEnabled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const toggleTempHelpSwitch = () => {
        setIsTempHelpEnabled(previousState => !previousState);

        if (!isTempHelpEnabled) {
            setIsOpen(true);
        }
        else {
            setIsOpen(false);
        }
    }

    function GetInfoEvaprator(idevap) {

        if (idevap != "") {
            Setissearching(true);
            fetch(`https://app.arshehkar.com/query/public/GetInfoEvapratorByModelTitle.php?id=${idevap}`)
                .then(response => response.json())
                .then(async (responseJsontmp) => {
                    if (responseJsontmp != null) {
                        setzarfiyatnami(responseJsontmp["zarfiyatnami"]);
                        setsizefan(responseJsontmp["sizefan"]);
                        setfaselefin(responseJsontmp["faselefin"]);
                        setsathtabadolhararat(responseJsontmp["sathtabadolhararat"]);
                        setgazgiri(responseJsontmp["gazgiri"]);
                        settedadfan(responseJsontmp["tedadfan"]);
                        setdebi(responseJsontmp["debi"]);
                        setpartabbad(responseJsontmp["partabbad"]);
                        setvorodi(responseJsontmp["vorodi"]);
                        setkhoroji(responseJsontmp["khoroji"]);
                        setvazn(responseJsontmp["vazn"]);
                        setsorat(responseJsontmp["sorat"]);
                        setip(responseJsontmp["ip"]);
                        setvoltajfan(responseJsontmp["voltajfan"]);
                        setferekans(responseJsontmp["ferekans"]);
                        setjaryanfan(responseJsontmp["jaryanfan"]);
                        settavanfan(responseJsontmp["tavanfan"]);
                        setvoltajdefrost(responseJsontmp["voltajdefrost"]);
                        setjaryandefrost(responseJsontmp["jaryandefros"]);
                        settavandefrost(responseJsontmp["tavandefrost"]);
                        seturlshematic(responseJsontmp["urlshematic"]);
                        SetFounded(true);
                        Setshowmessage('');

                    }
                    else {
                        setzarfiyatnami("-");
                        setsizefan("-");
                        setfaselefin("-");
                        setsathtabadolhararat("-");
                        setgazgiri("-");
                        settedadfan("-");
                        setdebi("-");
                        setpartabbad("-");
                        setvorodi("-");
                        setkhoroji("-");
                        setvazn("-");
                        setsorat("-");
                        setip("-");
                        setvoltajfan("-");
                        setferekans("-");
                        setjaryanfan("-");
                        settavanfan("-");
                        setvoltajdefrost("-");
                        setjaryandefrost("-");
                        settavandefrost("-");
                        seturlshematic("-");
                        SetFounded(false);
                        Setshowmessage(t('NOEvapratorFoundedUnderThisCondition'));
                    }

                })
            Setissearching(false);
        }



    }

    if (props.route.params.TYPE == 1) {


    }


    function searchquery() {
        var ressearch = "";
        if (searchedtxt != null && searchedtxt != "") {
            ressearch = searchedtxt.replace(/\s+/g, '-');
            SetSearchedTxt(ressearch);
            Setshowmessage(t('Searching'));
            // if (ressearch.charAt(3) != "-") {
            //    ressearch=ressearch.substring(0, 3) + "-" + ressearch.substring(3);
            //   SetSearchedTxt(ressearch);
            //}
            GetInfoEvaprator(ressearch);
        }
        else {
            alert(t('EnterEvaporatorForSearch'));
        }
    }

    const [foundd, SetFounded] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>

                <Text style={{ fontFamily: 'IranSans', fontSize: 13.8, padding: 10, marginRight: 10, color: 'black', fontWeight: 700 }}>{t('SearchByEvapratorModel')}</Text>

                <TextField
                    label={t('Evaporator')}
                    variant="filled"
                    placeholder={t('Evaporator')}
                    className={classes.textField}
                    required
                    InputProps={{
                        className: classes.input
                    }}
                    InputLabelProps={{
                        classes: { root: classes.labelRoot, shrink: classes.shrink }
                    }}
                    margin="normal"
                    onChange={(e) => SetSearchedTxt(e.target.value)}
                    value={searchedtxt}
                    onFocus={(e) => e.target.select()}
                    onWheel={(e) => e.target.blur()}
                />



                <TouchableOpacity style={styles.touchablesearch}
                    onPress={() => {
                        searchquery()
                    }}>

                    <Text style={styles.titlebutton}>{t('Search')}</Text>
                    <Icon name={"search"} color="#fff" size={20} style={{ marginLeft: 4 }} />
                </TouchableOpacity>





                <View style={{ marginBottom: 25 }}><Text style={{ fontFamily: 'IranSans', fontSize: 15, color: '#d12023' }}>{showmessage}</Text></View>




                {foundd && !issearching ?
                    <View style={{ flex: 1, flexDirection: 'row', width: '90%', justifyContent: 'center', alignContent: 'center', marginBottom: 30 }}>
                        <TouchableOpacity style={styles.touchable}
                            onPress={() => Setselectwich(3)}
                        ><Icon name={"arrow-down"} color={"black"} size={16} />
                            <Text style={styles.titleheader}> {t('schematic')} </Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.touchable}
                            onPress={() => Setselectwich(2)}
                        ><Icon name={"arrow-down"} color={"black"} size={16} />
                            <Text style={styles.titleheader}>{t('Technicaldata')}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.touchable}
                            onPress={() => Setselectwich(1)}
                        ><Icon name={"arrow-down"} color={"black"} size={16} />
                            <Text style={styles.titleheader}> {t('Specifications')}</Text>
                        </TouchableOpacity>
                    </View>
                    : null
                }

                {selectwhich == 1 && foundd && !issearching ?
                    <View style={[styles.container, { width: '100%' }]}>
                        <View style={styles.header}>
                            <Text style={styles.titleheader}> {t('Specifications')} </Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('KW')}</Text>
                            <Text style={styles.titleform}>{zarfiyatnami}</Text>
                            <Text style={styles.titleform}>{t('Nominalcapacity')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('M2')}</Text>
                            <Text style={styles.titleform}>{sathtabadolhararat}</Text>
                            <Text style={styles.titleform}>{t('surfaceareaofheattransfer')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('litre')}</Text>
                            <Text style={styles.titleform}>{gazgiri}</Text>
                            <Text style={styles.titleform}>{t('Circuitvol')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('PCS')}</Text>
                            <Text style={styles.titleform}>{tedadfan}</Text>
                            <Text style={styles.titleform}>{t('Nooffans')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('cm')}</Text>
                            <Text style={styles.titleform}>{sizefan}</Text>
                            <Text style={styles.titleform}>{t('FanDiameter')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('m3hr')}</Text>
                            <Text style={styles.titleform}>{debi}</Text>
                            <Text style={styles.titleform}>{t('Airflow')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('Meter')}</Text>
                            <Text style={styles.titleform}>{partabbad}</Text>
                            <Text style={styles.titleform}>{t('Airthrow')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('mm')}</Text>
                            <Text style={styles.titleform}>{faselefin}</Text>
                            <Text style={styles.titleform}>{t('Finspace')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{vorodi}</Text>
                            <Text style={styles.titleform}>{t('Inlet')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('inch')}</Text>
                            <Text style={styles.titleform}>{khoroji}</Text>
                            <Text style={styles.titleform}>{t('Outlet')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('kg')}</Text>
                            <Text style={styles.titleform}>{vazn}</Text>
                            <Text style={styles.titleform}>{t('Weight')}</Text>
                        </View>



                    </View>
                    : null}
                {selectwhich == 2 && foundd && !issearching ?
                    <View style={[styles.container, { width: '100%' }]}>



                        <View style={styles.header}>
                            <Text style={styles.titleheader}> {t('fanspecifications')} </Text>
                        </View>



                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('RPM')}</Text>
                            <Text style={styles.titleform}>{sorat}</Text>
                            <Text style={styles.titleform}>{t('speed')}</Text>
                        </View>


                        <View style={styles.formodd}>
                            <Text style={styles.titleform}></Text>
                            <Text style={styles.titleform}>{ip}</Text>
                            <Text style={styles.titleform}>IP</Text>
                        </View>


                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('V')}</Text>
                            <Text style={styles.titleform}>{voltajfan}</Text>
                            <Text style={styles.titleform}>{t('Voltage')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('Hz')}</Text>
                            <Text style={styles.titleform}>{ferekans}</Text>
                            <Text style={styles.titleform}>{t('Frequency')}</Text>
                        </View>


                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('A')}</Text>
                            <Text style={styles.titleform}>{jaryanfan}</Text>
                            <Text style={styles.titleform}>{t('Current')}</Text>
                        </View>


                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('KW')}</Text>
                            <Text style={styles.titleform}>{tavanfan}</Text>
                            <Text style={styles.titleform}>{t('Power')}</Text>
                        </View>



                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('electricdefrost')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('V')}</Text>
                            <Text style={styles.titleform}>{voltajdefrost}</Text>
                            <Text style={styles.titleform}>{t('Voltage')}</Text>
                        </View>

                        <View style={styles.formodd}>
                            <Text style={styles.titleform}>{t('A')}</Text>
                            <Text style={styles.titleform}>{jaryandefrost}</Text>
                            <Text style={styles.titleform}>{t('Current')}</Text>
                        </View>

                        <View style={styles.form}>
                            <Text style={styles.titleform}>{t('KW')}</Text>
                            <Text style={styles.titleform}>{tavandefrost}</Text>
                            <Text style={styles.titleform}>{t('Power')}</Text>
                        </View>

                    </View>
                    : null}
                {selectwhich == 3 && foundd && !issearching ?
                    <View style={[styles.container, { width: '100%' }]}>
                        <View style={styles.header}>
                            <Text style={styles.titleheader}>{t('schematic')}  </Text>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-around', margin: 15 }}>
                            <Switch
                                trackColor={{ false: "#767577", true: "#81b0ff" }}
                                thumbColor={isTempHelpEnabled ? "#f5dd4b" : "#f4f3f4"}
                                ios_backgroundColor="#3e3e3e"
                                onValueChange={toggleTempHelpSwitch}
                                value={isTempHelpEnabled}
                            />
                            <Text style={{ fontFamily: 'IranSans', fontSize: 11, color: '#06619b', marginLeft: 5, marginRight: 5 }} >{t('FitSizeImage')}</Text>
                        </View>
                        <View>
                            <TouchableOpacity onPress={() => { setIsTempHelpEnabled(true); setIsOpen(true) }}>
                                <Image style={{
                                    flex: 1, flexDirection: 'column', width: 400, height: 400, resizeMode: 'contain',
                                    alignSelf: 'center'
                                }} source={urlshematic}
                                />
                            </TouchableOpacity>
                        </View>


                        {isOpen && <Lightbox
                            mainSrc={urlshematic}
                            onCloseRequest={() => { setIsOpen(false); setIsTempHelpEnabled(false) }}
                        />}


                    </View>
                    : null}
                {foundd && !issearching ?
                    <ReactToPrint
                        trigger={() => <button style={{ margin: 15, padding: '7px 40px', direction: 'rtl', fontFamily: 'IranSans', cursor: 'pointer   ', fontSize: 12.8, verticalAlign: 'center', background: '#08598e', color: '#fff', border: 'none', borderRadius: 7, display: 'inline-flex' }}><img src="https://app.arshehkar.com/gallery/icons/exortpdf.png" style={{ width: 45, paddingLeft: 10 }} /><p>{t('Exporttopdf')}</p></button>}
                        content={() => componentRef.current}
                    />
                    : null
                }
                <div style={{ display: "none" }}>
                    <ComponentToPrintEvaprator person={{
                        zarfiyatnami: zarfiyatnami,
                        axevaprator: urlshematic,
                        selectedmodeltitle: searchedtxt,
                        sathtabadolhararat: sathtabadolhararat,
                        gazgiri: gazgiri,
                        tedadfan: tedadfan,
                        sizefan: sizefan,
                        debi: debi,
                        partabbad: partabbad,
                        faselefin: faselefin,
                        vorodi: vorodi,
                        khoroji: khoroji,
                        vazn: vazn,
                        sorat: sorat,
                        ip: ip,
                        voltajfan: voltajfan,
                        ferekans: ferekans,
                        jaryanfan: jaryanfan,
                        tavanfan: tavanfan,
                        voltajdefrost: voltajdefrost,
                        jaryandefrost: jaryandefrost,
                        tavandefrost: tavandefrost,
                    }} ref={componentRef} />
                </div>



            </SafeAreaView>
        </ScrollView>
    )
}

export default ResultEvaprator;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#fff',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        flex: 1,
        textAlign: 'center'
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',

        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',
        padding: 10,



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    formodd: {
        width: '90%',
        backgroundColor: '#e6e6e6',
        margin: 2,
        padding: 5,
        justifyContent: 'center',
        alignItems: 'stretch',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    }
    ,
    header: {
        width: '90%',
        backgroundColor: '#022a4c',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    headertop: {
        width: '90%',
        backgroundColor: '#82f7ff',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
    },
    titleheader: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 14,
        flex: 1,
        textAlign: 'center',
        color: 'white'
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
        elevation: 3,
        backgroundColor: '#4db6ac',
        margin: 5,
        height: 60,
        padding: 7,
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3, width: '30%'
    },
    titlebutton: {

        fontSize: 13,
        lineHeight: 21,
        fontWeight: 'bold',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',

    },
    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }
    ,
    titlepicker: {
        fontSize: 14, fontFamily: 'IranSans', width: '90%', textAlign: 'right', padding: 7
    },
    touchablesearch: {
        backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4, flexDirection: "row",
        justifyContent: "center",
        alignItems: "center", width: '82%'
    }
});